import { computed } from "vue";

import { useQuery } from "@tanstack/vue-query";

import { QUERY_KEYS } from "@/helpers/constants/queryKeys";
import offerTemplateService from "@/services/modules/offerTemplate";

import type { GetOfferTemplatesParams, OfferTemplate } from "@/models/offers";

export const useOfferTemplatesQuery = (
  payload: GetOfferTemplatesParams | (() => GetOfferTemplatesParams)
) => {
  return useQuery<OfferTemplate[]>({
    queryKey: computed(() => {
      const resolvedPayload =
        typeof payload === "function" ? payload() : payload;
      return QUERY_KEYS.OFFER_TEMPLATES.list(resolvedPayload);
    }),
    enabled: () => {
      const resolvedPayload =
        typeof payload === "function" ? payload() : payload;
      return !!resolvedPayload.ids?.length;
    },
    queryFn: async () => {
      const resolvedPayload =
        typeof payload === "function" ? payload() : payload;
      const offerTemplatesResponse =
        await offerTemplateService.getTemplates(resolvedPayload);

      return offerTemplatesResponse.data;
    },
  });
};
